module.exports = __webpack_public_path__ + "img/chart-line.3cf726cb.svg";